import React, { Fragment, useMemo } from 'react';
import classNames from 'classnames';
import { CandleData } from 'client/voladeum/candles/types';
import { FORMAT_TYPE } from 'cyprus/enums';
import { formatValue } from 'cyprus/formats';
import { Tooltip } from 'framework/Tooltip';
import moment from 'moment';

import { Card } from 'components/cards/Card';

import { EMPTY_ARRAY } from '../../../../constants';

import { CandleTooltip } from './CandleTooltip';
import { CandleHeatmapProps } from './types';

import cn from './CandleHeatmap.module.scss';

const HOURS = [0, 6, 12, 18, 23];

export const CandleHeatmap: React.FC<CandleHeatmapProps> = ({ candles = EMPTY_ARRAY }) => {
  const map = useMemo(() => {
    const m = new Map<number, CandleData>();
    for (const candle of candles) {
      const d = new Date(candle.x);
      const idx = d.getUTCHours() * 60 + d.getUTCMinutes();
      m.set(idx, candle);
    }
    return m;
  }, [candles]);

  return (
    <Card fit>
      <div className={cn.content}>
        <h2>Candle Minutes</h2>
        <div className={cn.grid}>
          {Array.from({ length: 24 }, (_, hour) => (
            <Fragment key={hour}>
              <div className={cn.hour}>
                {HOURS.includes(hour)
                  ? moment.utc().startOf('day').add(hour, 'hours').format('h A')
                  : ''}
              </div>
              {Array.from({ length: 60 }, (_, minute) => {
                const idx = hour * 60 + minute;
                const candle = map.get(idx);
                const base = moment.utc().startOf('day');
                const unix = base.clone().add(hour, 'hours').add(minute, 'minutes').valueOf();
                const title = formatValue(unix, { format: FORMAT_TYPE.UNIX_TIME, utc: true });

                return (
                  <Tooltip key={idx} information={<CandleTooltip title={title} candle={candle} />}>
                    <div
                      className={classNames(cn.cell, 'transition', { [cn.candle]: map.has(idx) })}
                    />
                  </Tooltip>
                );
              })}
            </Fragment>
          ))}
        </div>
      </div>
    </Card>
  );
};
